import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { showConfirmationModal } from "../redux-state/features/global-state/globalStateSlice";
const ConfirmationModal = ({ onConfirm, onCancel }) => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.globalState.showConfirmationModal);

  const handleClose = () => dispatch(showConfirmationModal(false));
  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };
  const HandleCancel = () => {
    onCancel();
    handleClose();
  };
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>تأكيد العملية</Modal.Title>
        </Modal.Header>
        <Modal.Body>هل أنت متأكد من أنّك تريد المتابعة</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={HandleCancel}>
            إلغاء العملية
          </Button>
          <Button variant="danger" onClick={handleConfirm}>
            نعم , أرغب في المتابعة
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmationModal;
